module.exports = {
  DAILY_CLAIM: 'dailyClaim',
  EXPLORATION: 'exploration',
  CUSTOM: 'custom',
};
